import * as React from 'react';

enum EPanoramaState {
  Loaded,
  None,
}

interface IUsePanoramaProps {
  isPanorama: boolean;
  handlePanoramaSuccessEnter: () => void;
  handleNoPanoramaEnter: () => void;
  handlePanoramaExit: () => void;
}

export const usePanoramaProps = (): IUsePanoramaProps => {
  const [panoramaState, setPanoramaState] = React.useState<EPanoramaState | null>(null);

  const handlePanoramaSuccessEnter = React.useCallback(() => {
    setPanoramaState(EPanoramaState.Loaded);
  }, []);

  const handleNoPanoramaEnter = React.useCallback(() => {
    setPanoramaState(EPanoramaState.None);
  }, []);

  const handlePanoramaExit = React.useCallback(() => {
    setPanoramaState(null);
  }, []);

  const isPanorama = panoramaState !== null;

  return {
    isPanorama,
    handlePanoramaSuccessEnter,
    handleNoPanoramaEnter,
    handlePanoramaExit,
  };
};
